import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { ConfigServerService, CustomHttp } from '../../../../core';
import { ProdutividadeFilter, Produtividade } from '../adapters';
import { PRODUTIVIDADE_KPIS_API_RESOURCE } from '../const';

@Injectable({
    providedIn: 'root'
})
export class ProdutividadeHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getKPIsAPIResource()}/${PRODUTIVIDADE_KPIS_API_RESOURCE}`;
    }

    /** Carrega os KPIs de Produtividade */
    get(filter: ProdutividadeFilter): Observable<Produtividade> {
        // Params
        let params = new HttpParams()
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<Produtividade>(this.pathApi, {params})
                    .pipe(
                        map(produtividade => Produtividade.fromJSON(JSON.stringify(produtividade)))
                    );
    }
}
